export function getFieldConfig(fieldSettings, key, defaults = {}) {
  return {
    ...defaults,
    ...(fieldSettings?.[key] || {})
  }
}

export function getNestedFieldConfig(fieldSettings, parentKey, childKey, defaults = {}) {
  return {
    ...defaults,
    ...(fieldSettings?.[parentKey]?.fields?.[childKey] || {})
  }
}